import { colors, typography, layout } from '../../styles/theme';
import { ADMIN_RAIL, ADMIN_SURFACE } from '../adminUi';

export const adminRootSx = {
  height: '100dvh',
  maxHeight: '100dvh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  bgcolor: ADMIN_RAIL,
  color: colors.textPrimary,
  fontFamily: typography.fontFamily.primary,
};

export const adminHeaderSx = {
  height: layout.mapHeaderHeight,
  minHeight: layout.mapHeaderHeight,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: { xs: 1.5, sm: 2.5 },
  gap: 2,
  bgcolor: ADMIN_SURFACE,
  borderBottom: `1px solid ${colors.border}`,
  boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
};

export const adminHeaderBrandSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  minWidth: 0,
};

const ENV_BADGE = {
  local: { color: colors.primary, border: colors.primary },
  development: { color: colors.warning, border: colors.warning },
  production: { color: colors.error, border: colors.error },
};

export const adminEnvBadgeSx = (env) => {
  const tone = ENV_BADGE[env] || ENV_BADGE.development;
  return {
    flexShrink: 0,
    fontFamily: typography.fontFamily.primary,
    fontSize: '11px',
    fontWeight: typography.fontWeight.semibold,
    letterSpacing: '0.04em',
    lineHeight: '16px',
    px: 1,
    py: '2px',
    borderRadius: '6px',
    border: `1px solid ${tone.border}`,
    color: tone.color,
  };
};

export const adminHeaderTitleSx = {
  fontFamily: typography.fontFamily.heading,
  fontWeight: typography.fontWeight.semibold,
  fontSize: '16px',
  lineHeight: '20px',
  color: colors.textPanelTitle,
  m: 0,
  whiteSpace: 'nowrap',
};

export const adminHeaderActionsSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexShrink: 0,
};

export const adminBodySx = {
  flex: 1,
  display: 'flex',
  minHeight: 0,
};

export const adminNavSx = {
  width: { xs: 72, sm: 220 },
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 0.25,
  p: { xs: 1, sm: 1.5 },
  borderRight: `1px solid ${colors.border}`,
  bgcolor: ADMIN_SURFACE,
  overflowY: 'auto',
};

export const adminNavSectionSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.25,
  '& + &': {
    mt: 1.25,
    pt: 1.25,
    borderTop: `1px solid ${colors.border}`,
  },
};

export const adminNavSectionLabelSx = {
  display: { xs: 'none', sm: 'block' },
  px: 1.5,
  mb: 0.5,
  fontFamily: typography.fontFamily.primary,
  fontSize: '11px',
  fontWeight: typography.fontWeight.semibold,
  letterSpacing: '0.06em',
  lineHeight: '16px',
  textTransform: 'uppercase',
  color: 'rgba(255,255,255,0.38)',
};

export const adminNavItemSx = (active, { featured = false } = {}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1.25,
  width: '100%',
  minHeight: 40,
  px: { xs: 1, sm: 1.5 },
  justifyContent: { xs: 'center', sm: 'flex-start' },
  border: 'none',
  borderRadius: '8px',
  bgcolor: active ? colors.backgroundDark : 'transparent',
  color: active
    ? colors.primary
    : featured
      ? 'rgba(255,255,255,0.92)'
      : 'rgba(255,255,255,0.78)',
  fontFamily: typography.fontFamily.primary,
  fontSize: '14px',
  fontWeight: active || featured ? 600 : 500,
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    bgcolor: colors.backgroundDark,
  },
});

/** El main no scrollea: título y filtros quedan fijos; scrollea cada listado. */
export const adminMainSx = {
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  p: { xs: 2, sm: 3 },
  '& > *': {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
  },
};

export const adminHeaderLinkSx = {
  textTransform: 'none',
  color: 'rgba(255,255,255,0.72)',
  fontSize: '13px',
  fontWeight: 500,
  px: 1.25,
  minHeight: 32,
  '&:hover': {
    bgcolor: 'rgba(255,255,255,0.06)',
  },
};

export const adminBootSx = {
  minHeight: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
  bgcolor: ADMIN_RAIL,
  color: colors.textPanelTitle,
};
